import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { studeptlist } from "../../../services/master";
import {
  teacherdelete,
  teacherfilter,
  teacherleft,
} from "../../../services/teacher";
import Select from "react-select";
import { toast } from "react-toastify";
import { academylist } from "../../../services/admin";
import moment from "moment";

export default function Leftteacher() {
  const navigate = useNavigate();
  const [photo, setPhoto] = useState("");
  const [dept, setDept] = useState("");
  const [dlist, setDList] = useState([]);
  const [tlist, setTList] = useState([]);
  const [tealist, setTeaList] = useState([]);
  const [stuid, setStuId] = useState("");
  const [leftby, setLeftBy] = useState("");

  const [loading, setLoading] = useState(false);

  const [tpath, setTPath] = useState("");
  const [urllink, setUrllink] = useState("");

  const [alist, setAList] = useState([]);
  const [acaid, setAcaID] = useState("");

  const [uname, setUName] = useState("");
  const location = useLocation();
  useEffect(() => {
    if(localStorage.getItem("ADate") !== ''){
      setLDate(moment(localStorage.getItem("ADate")).format("YYYY-MM-DD"));
    }else{
      setLDate(moment(new Date()).format("YYYY-MM-DD"));
    }

    const path = location.pathname.split("/")[2]; // Extracts 'allteacher' or 'leftteacherlist'
    setUrllink(path);
    if (path === "leftteacher") {
      setUName("Left");
    } else if (path === "deleteteacher") {
      setUName("Delete");
    }
    studeptlist().then((res) => {
      if (res.status === true) {
        setDList(res.data);
      }
    });
    academylist().then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.details.length > 0) {
          for (let i = 0; i < res.data.details.length; i++) {
            arr.push({
              value: res.data.details[i].id,
              label:
                res.data.details[i].name + " - " + res.data.details[i].code,
            });
          }
          setAList(arr);
        }
      }
    });

    if (localStorage.getItem("AAcademy") != null) {
            academylist().then((res) => {
              if (res.status === true) {
                let arr = [];
                if (res.data.details.length > 0) {
                  for (let i = 0; i < res.data.details.length; i++) {
                    if (res.data.details[i].id == localStorage.getItem("AAcademy")) {
                      arr.push({
                        value: res.data.details[i].id,
                        label:
                          res.data.details[i].name + " - " + res.data.details[i].code,
                      });
                    }
                    setAcaID(arr[0]);
                  }
                }
              }
            });
          }
  }, [location.pathname]);

  function errorphoto(ev) {
    ev.target.src = require("../../../assets/images/teacher.jpg");
    ev.target.onerror = null;
  }

  function filterstu(aca,dep) {
    setTeaList([]);
    setTList([]);
    setTPath("");
    setStuId("");
    setPhoto("");
    if (dep !== "") {
      const temp = new FormData();
      temp.append("dept", dep);
      if(localStorage.getItem("Role") === "1" && aca !== ""){
        temp.append("academy", aca.value);
      }
      teacherfilter(temp).then((res) => {
        if (res.status === true) {
          let arr = [];
          setTPath(res.data.path);
          setTList(res.data.details);
          if (res.data.details.length > 0) {
            for (let i = 0; i < res.data.details.length; i++) {
              arr.push({
                value: res.data.details[i].id,
                label: res.data.details[i].username + " - " + res.data.details[i].teacher_name,
              });
            }
          }
          setTeaList(arr);
        }
      });
    }
  }

  function handleTea(e) {
    setPhoto("");
    setStuId("");
    if (e !== null) {
      setStuId(e);
      if (tlist.length > 0) {
        const rdata = tlist.find((item) => item.id == e.value);

        if (rdata !== undefined) {
          if (rdata.photo !== null) {
            setPhoto(tpath + rdata.photo);
          }
        }
      }
    } else {
      setStuId("");
      setPhoto("");
    }
  }

  const [errmsg, setErrMsg] = useState("");
  const [ldate, setLDate] = useState("");
  const [lreason, setLReason] = useState("");
  const [lremark, setLRemark] = useState("");

  function subleft(e) {
    e.preventDefault();
    setErrMsg("");
    let valid=""
    if (localStorage.getItem("Role") === "1") {
      if (acaid === "") {
        setErrMsg("Please Select Academy");
        valid = "Please Select Academy";
      }
    } else {
      valid = "";
    }
    if(valid === ""){
      if (dept !== "") {
        if (stuid !== "") {
          if (ldate !== "") {
            if (lreason !== "") {
              setLoading(true);
              const temp = new FormData();
              temp.append("id", stuid.value);
              temp.append("date", ldate);
              temp.append("reason", lreason);
              temp.append("remark", lremark);
              temp.append("delete_by", localStorage.getItem("UID"));
              if (localStorage.getItem("Role") === "1" && acaid !== "") {
                temp.append("academy", acaid.value);
              }
              if (urllink === "leftteacher") {
                teacherleft(temp).then((res) => {
                  if (res.status === true) {
                    setLoading(false);
                    navigate("/teacher/leftteacherlist");
                    toast.success(res.message);
                  } else {
                    setLoading(false);
                    toast.error(res.message);
                  }
                });
              } else {
                teacherdelete(temp).then((res) => {
                  if (res.status === true) {
                    setLoading(false);
                    navigate("/teacher/deleteteacherlist");
                    toast.success(res.message);
                  } else {
                    setLoading(false);
                    toast.error(res.message);
                  }
                });
              }
            } else {
              setErrMsg("Please Enter " + uname + " Reason");
            }
          } else {
            setErrMsg("Please Select " + uname + " Date");
          }
        } else {
          setErrMsg("Please Select Teacher");
        }
      } else {
        setErrMsg("Please Select Department");
      }
    }
    
  }

  function backlist() {
    if (urllink === "leftteacher") {
      navigate("/teacher/leftteacherlist");
    } else if (urllink === "deleteteacher") {
      navigate("/teacher/deleteteacherlist");
    }
  }

  function handleAcademy(e) {
    if (e !== null) {
      setAcaID(e);
      filterstu(e,dept)
    } else {
      setAcaID("");
      filterstu("",dept)

    }
  }
  return (
    <div>
      <div className="page-header">
        <h2 className="main-content-title tx-24 mg-b-5">{uname} Teacher</h2>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>Teacher</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            {uname} Teacher
          </li>
        </ol>
      </div>
      <div className="content-body">
        <div className="container-fluid">
          <div className="row">
            <div className="col-xl-12">
              <div className="card">
                <div className="card-header">
                  <h2 className="main-content-title tx-24 mg-b-5">
                    {uname} Teacher
                  </h2>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-xl-3 col-lg-4">
                      <label className="form-label">Photo</label>
                      <div className="avatar-upload">
                        <div className="avatar-preview">
                          <img
                            src={photo}
                            onError={(e) => errorphoto(e)}
                            alt="Student"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-9 col-lg-8">
                      <div className="row">
                        {localStorage.getItem("Role") === "1" && (
                          <div className="col-xl-6 col-sm-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Select Academy{" "}
                                <span className="text-danger"> *</span>
                              </label>
                              <Select
                                className="default-select"
                                placeholder="Select Academy"
                                value={acaid}
                                options={alist}
                                onChange={handleAcademy}
                                isSearchable={true}
                                isClearable
                                hidden
                              />
                            </div>
                          </div>
                        )}
                        <div className="col-xl-6 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Department <span className="text-danger"> *</span>
                            </label>
                            <select
                              className="default-select form-control wide"
                              value={dept}
                              onChange={(e) => setDept(e.target.value)}
                              onBlur={(e) => filterstu(acaid,e.target.value)}
                            >
                              <option value="" disabled>
                                Select Department
                              </option>

                              {dlist.map((item) => {
                                return (
                                  <option value={item.id} key={item.id}>
                                    {item.dept_name}
                                  </option>
                                );
                              })}
                            </select>
                          </div>
                        </div>
                        <div className="col-xl-6 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Teacher Name{" "}
                              <span className="text-danger"> *</span>
                            </label>
                            <Select
                              className="default-select"
                              placeholder="Select Teacher"
                              value={stuid}
                              options={tealist}
                              onChange={handleTea}
                              isSearchable={true}
                              isClearable
                              hidden
                            />
                          </div>
                        </div>
                        <div className="col-xl-6 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label">
                              {uname} Date{" "}
                              <span className="text-danger"> *</span>
                            </label>
                            <div className="input-group">
                              <input
                                className="form-control"
                                type="date"
                                value={ldate}
                                onChange={(e) => setLDate(e.target.value)}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-xl-6 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Reason for Leaving{" "}
                              <span className="text-danger"> *</span>
                            </label>
                            <div className="input-group">
                              <input
                                className="form-control"
                                type="text"
                                placeholder="Enter Reason"
                                value={lreason}
                                onChange={(e) => setLReason(e.target.value)}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-xl-6 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label">Remark</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Remark"
                              value={lremark}
                              onChange={(e) => setLRemark(e.target.value)}
                            />
                          </div>
                        </div>
                        {/*<div className="col-xl-6 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label">
                              {uname} By <span className="text-danger"> *</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Your Credential"
                              value={leftby}
                              onChange={(e) => setLeftBy(e.target.value)}
                            />
                          </div>
                        </div> */}
                      </div>
                      {errmsg !== "" && (
                        <span className="text-danger">{errmsg}</span>
                      )}
                      <div className="res-right mt-2 me-4">
                        <button
                          className="btn btn-success me-2"
                          onClick={subleft}
                        >
                          Submit
                        </button>
                        <button
                          className="btn btn-secondary"
                          onClick={backlist}
                        >
                          Back
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
